import { ChangeDetectorRef, Component, OnInit } from "@angular/core";
import { EmployeeService } from "../../shared/service/employee.service";
import { ExitReason } from "../../../Models/ExitReason";
import {
  ReactiveFormsModule,
  FormGroup,
  FormControl,
  FormBuilder,
  Validators,
} from "@angular/forms";
import { HRStatus, Offboarding } from "../../shared/models/Offboarding";
import { ToastrService } from "ngx-toastr";
import {
  MomentDateAdapter,
  MAT_MOMENT_DATE_ADAPTER_OPTIONS,
} from "@angular/material-moment-adapter";
import {
  DateAdapter,
  MAT_DATE_FORMATS,
  MAT_DATE_LOCALE,
} from "@angular/material/core";
import { MatDialog } from "@angular/material";
import * as _moment from "moment";
import { AppConfig } from "../../app.config";
import { Router, ActivatedRoute } from "@angular/router";
import { DatePipe } from "@angular/common";
import { UserService } from "../../shared/service/user.service";
import { ExitReasonDetails } from "../../shared/models/ExitReasonDetails";
import { isNullOrUndefined } from "util";
import { OffbaordingFeedbackTypeClass } from "../../shared/models/OffbaordingFeedbackTypeClass";
import { FileUploadService } from "../../shared/service/fileUpload.service";
import { File_Types } from "../../shared/UploadFileTypes";
import { Moment } from "moment";
import { UpdateOffboardingResgnStatus } from "../../shared/models/UpdateOffboardingResgnStatus";
import { isNotNullOrUndefined } from "codelyzer/util/isNotNullOrUndefined";
import { ConfirmDialogComponent, ConfirmDialogModel } from "../../shared/components/confirm-dialog/confirm-dialog.component";
import { ReasonDialogComponent } from "../reason-dialog/reason-dialog.component";
const moment = _moment;
export const MY_FORMATS = {
  parse: {
    dateInput: "DD-MMM-YYYY",
  },
  display: {
    dateInput: "DD-MMM-YYYY",
    monthYearLabel: "MMM YYYY",
    dateA11yLabel: "LL",
    monthYearA11yLabel: "MMMM YYYY",
  },
};

@Component({
  selector: "app-add-offboarding-details",
  templateUrl: "./add-offboarding-details.component.html",
  styleUrls: ["./add-offboarding-details.component.css"],
  providers: [
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
    },

    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ],
})
export class AddOffboardingDetailsComponent implements OnInit {
  exitReason: ExitReason;
  offboardingForm: FormGroup;
  exitcategorylist: any[];
  reasonlist: any[];
  offboarding: Offboarding;
  todayDate: Date;
  exitReasons: any;
  fileoffboarding: any;
  error: string;
  exception = false;
  empCode: any;
  datePipe: DatePipe;
  offboardinglist: ExitReasonDetails[];
  reasonDetail: string;
  exitreasonid: number;
  empName: any;
  LoginEmpCode: any;
  ProjectMgr: any;
  employeeList: any[] = [];
  emplist: Offboarding[] = [];
  filteredList: any;
  resultArray: Offboarding[] = [];
  EmployeeCode: any;
  employeeId: any;
  MAX_SIZE: number = 1048576;
  minResigDate: Moment;
  minDate: Date;
  exitcategoryComments: string;
  peopleManagerEmail: string;
  peopleManagerName: string;
  employeeDisplayList: any[] = [];
  displayInitiateExit: boolean = false;
  displaySave: boolean = false;
  displayReject: boolean = false;
  displayReset: boolean = false;
  empDOJ: Date;
  resminCode: any;
  loader: boolean;
  hideOffboardingEmpList: any[] = [];
  onlyIndianEmployees: any[] = [];
  EmpInit: any;
  offboardingID: number = null;
  updateOffboardingResgnStatus: UpdateOffboardingResgnStatus;
  commentsReq = false;
  disabled = false;
  poList: any;
  selectedPO: any;
  selected: any = null;
  finalShowCC: string[];
  selectedMasterIds: any = null;
  disable = false;
  empList: any;
  ccEntries: any[] = [];
  originalCClength;
  filteredEmpList: any[] = [];
  MaxItems: number;
  permission: any;
  pmList: any;
  selectedPM: any;
  hasAddPermission = false;

  constructor(
    private empsvc: EmployeeService,
    private formBuilder: FormBuilder,
    private userService: UserService,
    private config: AppConfig,
    private router: Router,
    private toastr: ToastrService,
    private route: ActivatedRoute,
    public dialog: MatDialog,
    private file_Svc: FileUploadService,
    private _userService: UserService,
    public cdr: ChangeDetectorRef
  ) {
    this.todayDate = new Date();
    this.empDOJ = new Date();
    //this.minResigDate. = new Date().;
    this.fileoffboarding = new Offboarding();
    const currentYear = moment().year();
    this.minResigDate = moment([currentYear - 1, 8, 1]);
    this.updateOffboardingResgnStatus = new UpdateOffboardingResgnStatus();
  }

  ngOnInit() {
    this.route.params.subscribe((params) => {
      this.offboardingID = params["empCode"];
    });
    this.getOffboardingdetailsbyCode();
    this.getEmployeeListforCC();
    this.permission = this._userService.userInfo.permissions.find(
      (i) => i.Name === "Offboarding-list"
    );
    this.hasAddPermission = this.permission != null ? this.permission.AddingPermission || this.permission.HasFullAccess : false;
    this.offboarding = new Offboarding();
    this.LoginEmpCode = this.userService.getEmpCode();

    this.displaySave = true;
    this.displayReject = false;
    this.displayReset = true;

    if (!isNullOrUndefined(this.offboardingID)) {
      this.offboardingForm = this.formBuilder.group({
        ResignationDate: [moment(), [Validators.required]],
        IndicativeLWD: [moment(), Validators.required],
        LastWorkingDay: [moment(), Validators.required],
        ExitID: ["", [Validators.required]],
        ReasonID: ["", [Validators.required]],
        Comments: ["", []],
        employeeId: ["", [Validators.required]],
        ExitEmailFile: ["",[]],
        ReasonComments: ["", [Validators.required]],
        HRResignationComments: ["", [Validators.required]],
        ManagerResignationComments: ["", []],
        To: ["", [Validators.required]],
        CC: ["", [Validators.required]],
        ProjectManagers: ["", [Validators.required]],
      });

      this.getActiveProjectManagers();
      this.getActivePeopleManager();
      this.getOffboardingdetailsbyCode();
      this.getEmployeeList();
      this.getExitReasons();
      this.getexitreasonbyid();
    } else {
      this.getEmployeeList();
      this.getOffboardingdetails();
      this.getActiveProjectManagers();
      this.getActivePeopleManager();
      const nonWhitespaceRegExp: RegExp = new RegExp("\\S");
      this.offboardingForm = this.formBuilder.group({
        ResignationDate: [moment(), [Validators.required]],
        IndicativeLWD: [moment(), [Validators.required]],
        LastWorkingDay: [moment(), Validators.required],
        ExitID: ["", [Validators.required]],
        ReasonID: ["", [Validators.required]],
        Comments: ["", [Validators.required]],
        employeeId: ["", [Validators.required]],
        ExitEmailFile: ["", []],
        ReasonComments: ["", [Validators.required]],
        HRResignationComments: [""],
        ManagerResignationComments: [""],
        To: [""],
        CC: [""],
        ProjectManagers: ["", [Validators.required]],
      });
      this.getExitReasons();
      this.getexitreasonbyid();
    }
  }
  get f() {
    return this.offboardingForm.controls;
  }
  resetManagers() {
    this.poList = [];
    this.selectedPO = [];
    this.selected = "";
    this.pmList = [];
    this.selectedPM = [];
  }

  getDOJ(event) {
    var id = event.option.value.split("-");
    this.resminCode = id[0];

    this.resetManagers();

    this.getDOJEmployeebyCode();
    this.getActiveProjectManagers();
    this.getActivePeopleManager();
    this.getOffboardingdetailsbyCode();
  }
  getDOJEmployeebyCode() {
    if (!isNullOrUndefined(this.empCode)) {
      this.getPeopleManagerCodeandMail(this.empCode);
      this.empsvc.getBasicEmployeeById(this.empCode).subscribe((data: any) => {
        this.empDOJ = data.DOJ;
      });
    } else {
      this.getPeopleManagerCodeandMail(this.resminCode);
      this.empsvc
        .getBasicEmployeeById(this.resminCode)
        .subscribe((data: any) => {
          this.empDOJ = data.DOJ;
        });
    }
  }
  autoGrowTextZone(e) {
    e.target.style.height = "0px";
    e.target.style.height = e.target.scrollHeight + 10 + "px";
  }
 

  getActivePeopleManager() {
    const codeToUse = this.empCode || this.resminCode;

    if (codeToUse) {
      this.empsvc.getActivePeopleManagerByCode(codeToUse).subscribe(
        (data: any) => {
          this.pmList = data;
          this.selectedPM = this.pmList;
          this.getEmployeeListforCC();
        },
        (error) => {
          console.error("Error fetching people managers:", error);
        }
      );
    }
  }

  getActiveProjectManagers() {
    const codeToUse = this.resminCode;
    if (codeToUse) {
      this.empsvc
        .getActiveProjectManagersByCode(codeToUse)
        .subscribe((data: any) => {
          this.poList = data;
          if (this.poList) {
            this.selectedPO = this.poList;
            this.selected =
              this.poList != null && this.poList.split(",").length > 1
                ? this.poList.split(",").join(", ")
                : this.selectedPO;
            this.getEmployeeListforCC();
          }
        });
    }
  }

  getOffboardingdetailsbyCode() {
    if (this.offboardingID != null) {
      this.empsvc
        .getOffboardingDetailsById(this.offboardingID)
        .subscribe((data: any) => {
          if (!data) {
            this.toastr.error("get Offboarding details by id not found");
            return;
          }
          this.offboarding = data || new Offboarding();
          this.empCode = this.offboarding && this.offboarding.EmpCode;
          this.empName = this.offboarding && this.offboarding.Name;
          this.ProjectMgr = this.offboarding && this.offboarding.ProjectManagers;

          //this.removeSaveOnInitiate = true;
          //this.displayInitiateExit = false;
          //this.displaySave = true;
          //this.displayReject = true;
          //this.disabled = false;

          //status = saved && finalStatus = Saved
          if (this.offboarding && this.offboarding.finalStatus === "Saved") {
            this.displaySave = true;
            this.displayInitiateExit = true;
            this.displayReject = true;
            this.displayReset = false;
          }

          if (
            this.offboarding.finalStatus === "Saved" &&
            this.offboarding.Status === "Saved"
          ) {
            this.displaySave = true;
            this.displayInitiateExit = true;
            this.displayReject = false;
            this.displayReset = false;
          }

          if (this.offboarding.finalStatus === "Submitted") {
            this.displaySave = false;
            this.displayInitiateExit = false;
            this.displayReject = false;
            this.displayReset = false;
            this.offboardingForm.disable();
          }

          //status = Initiated and when HR saves && finalStatus = Initiated
          else if (
            this.offboarding.finalStatus === "Initiated" &&
            this.offboarding.Status === "Initiated"
          ) {
            this.displaySave = false;
            this.displayInitiateExit = true;
            this.displayReject = false;
            this.displayReset = false;
          }

          //status == saved and final status = confirmed
          else if (
            this.offboarding.finalStatus === "Confirmed" &&
            this.offboarding.Status === "Saved"
          ) {
            this.displaySave = true;
            this.displayInitiateExit = true;
            this.displayReject = true;
            this.displayReset = false;
          } else if (
            this.offboarding.finalStatus === "Confirmed" &&
            this.offboarding.Status === "Initiated"
          ) {
            this.displaySave = false;
            this.displayInitiateExit = true;
            this.displayReject = true;
            this.displayReset = false;
          }

          //status= null and finalstatus = "approved"
          //else if (this.offboarding.finalStatus === "Confirmed") {

          //  this.displaySave = true;
          //  this.displayInitiateExit = false;
          //  this.displayReject = true;
          //  this.displayReset = false;
          //}
          else if (this.offboarding.finalStatus === "Approved") {
            this.displaySave = true;
            this.displayInitiateExit = false;
            this.displayReject = true;
            this.displayReset = false;
          } else if (this.offboarding.Status === "Submitted to Finance") {
            this.displaySave = false;
            this.displayInitiateExit = false;
            this.displayReject = false;
            this.displayReset = false;
            this.offboardingForm.disable();
          } else if (
            this.offboarding.Status === "In Process" ||
            this.offboarding.Status === "Completed" ||
            this.offboarding.finalStatus === "Rejected" ||
            this.offboarding.finalStatus === "Revoked"
            // || this.permission.AddingPermission
          ) {
            this.displaySave = false;
            this.displayInitiateExit = false;
            this.displayReject = false;
            this.displayReset = false;
            this.offboardingForm.disable();
          }

          if (this.offboarding.ResignationDate) {
            this.setLastWorkingDate(this.offboarding.ResignationDate);
          }

          if (this.offboarding.CC) {
            const ccEntries = this.offboarding.CC.split(",").map((entry) => {
              const [recDisplayName, empCode] = entry.split(" - ");
              return { recDisplayName, empCode: Number(empCode) };
            });
            this.selectedMasterIds = ccEntries.map((entry) => entry.empCode);
          }
          this.originalCClength = Number(
            JSON.parse(
              JSON.stringify(
                this.selectedMasterIds != "" || this.selectedMasterIds != null
                  ? this.selectedMasterIds && this.selectedMasterIds.length
                  : 0
              )
            )
          );
          this.getPeopleManagerCodeandMail(this.empCode);
          this.getDOJEmployeebyCode();
          //this.getActiveProjectManagers();
          this.getActivePeopleManager();
          this.reasons(this.offboarding.ExitID);
          this.exitreasonid = this.offboarding.ReasonID;
        });
    }
  }

  getFileName() {
    if (this.offboarding.ExitEmailFileName != null)
      return this.offboarding.EmpCode + "_Resignation email";
    else return null;
  }
  //the below method is to hide clear icon for all values
  //shouldHideClearIcon(item: any): boolean {
  //  var cc = null;
  //  if (this.offboarding.CC != null) {
  //    const ccEntries = this.offboarding.CC.split(",");
  //    cc = ccEntries.map((entry) => {
  //      const empcode = entry;
  //      return empcode;
  //    });
  //  }
  //  return cc.includes(item.recDisplayName);
  //}

  //the below method is to show clear icon for all values
  shouldHideClearIcon(item: any): boolean {
    const isEditable =
      this.offboarding.Status === "saved" ||
      this.offboarding.Status === "initiated";
    let cc = null;
    if (this.offboarding.CC != null) {
      const ccEntries = this.offboarding.CC.split(",");
      cc = ccEntries.map((entry) => entry.trim());
    }
    return isEditable && cc.includes(item.recDisplayName);
  }

  removeSelectedId(item: any): void {
    this.selectedMasterIds = this.selectedMasterIds.filter(
      (id) => id !== item.EmpCode
    );
    let originalSelectedCC: number[] = [];

    if (this.offboarding.CC) {
      this.finalShowCC = this.offboarding.CC.split(",");

      originalSelectedCC = this.finalShowCC.map((entry) => {
        const [, EmpCode] = entry.split(" - ");
        return Number(EmpCode);
      });
    }

    const originalLength = originalSelectedCC.length;
    const selectedLength = this.selectedMasterIds.length;

    if (
      (originalLength > 0 && selectedLength - originalLength >= 2) ||
      (originalLength === 0 && selectedLength >= 2) ||
      this.offboarding.finalStatus !== HRStatus.Submit
    ) {
      this.disable = true;
    } else {
      this.disable = false;
    }
    this.cdr.detectChanges();
  }

  updateFilteredEmpList() {
    this.filteredEmpList = this.empList.filter(
      (emp) => !this.selectedMasterIds.includes(emp.EmpCode)
    );
  }

  onChangeCC(val) {
    if (!this.selectedMasterIds) {
      this.selectedMasterIds = [];
    }
    if (Array.isArray(val)) {
      val.forEach((item) => {
        this.selectedMasterIds.push(item);
      });
    } else {
      this.selectedMasterIds.push(val);
    }
    this.updateFilteredEmpList();
  }

  onChangeCCValues(selectedIds: string[]) {
    if (!this.offboarding.CC) {
      this.offboarding.CC = "";
    }
    this.finalShowCC = this.offboarding.CC.split(",");

    let originalSelectedCC: number[] = this.finalShowCC.map((entry) => {
      const [, EmpCode] = entry.split(" - ");
      return Number(EmpCode);
    });

    const originalLength = originalSelectedCC.length;
    const selectedLength = selectedIds.length;

    if (
      (originalLength > 0 && selectedLength - originalLength >= 3) ||
      (originalLength === 0 && selectedLength >= 3) ||
      this.offboarding.finalStatus !== HRStatus.Submit
    ) {
      this.disable = true;
    } else {
      this.disable = false;
    }

    this.cdr.detectChanges();
  }

  getDisplayName(id: number): string | undefined {
    return this.selectedMasterIds
      .map((id) => {
        const employee = this.filteredEmpList.find(
          (emp) => emp.recEmpCode === id
        );
        return employee ? employee.recDisplayName : null;
      })
      .filter((name) => name)
      .join(", ");
  }

  getMaxItemsLength() {
    if (this.originalCClength) {
      this.MaxItems = this.originalCClength + 2;
      return this.originalCClength + 2;
    }
    else {
      this.MaxItems = 7;
    }  
  }

  getOffboardingdetails() {
    this.empsvc.getAllOffboardingDetails().subscribe(
      (data: Offboarding[]) => {
        this.emplist = data;
      },
      (error) => {
        this.error = error;
      }
    );
  }

  InitiateOffboarding() {
    this.offboarding.clickingInitaiteExit = true;
    this.empsvc.InitiateOffboardingDetails(this.offboarding).subscribe(
      (data: Offboarding) => {
        this.toastr.success("Exit Initiated Successfully.");
        this.loader = false;
        this.router.navigateByUrl("/Offboardinglist/tabIndex/0");
      },
      (error) => (this.error = error)
    );
  }

  getexitreasonbyid() {
    this.empsvc.GetExitReasonByID(1).subscribe();
    this.loader = false;
  }
  getExitReasons() {
    this.empsvc.GetExitReasons().subscribe((data: any) => {
      this.exitcategorylist = data;
    });
  }

  getsavedreasons(reasonid: number) {
    this.empsvc.getReasons().subscribe((data: any) => {
      var category = data.filter((x) => x.ReasonID == reasonid);
      return category[0].ExitReasonDetails;
    });
  }

  reasons(event: any) {
    if (event == 1) {
      this.empsvc.GetExitReasonByID(event).subscribe((data: any) => {
        this.reasonlist = data;
      });
    } else if (event == 2) {
      this.empsvc.GetExitReasonByID(event).subscribe((data: any) => {
        this.reasonlist = data;
      });
    } else {
      this.empsvc.getReasons().subscribe((data: any) => {
        this.reasonlist = data;
      });
    }
  }

  addNewReason() {
    const dialogRef = this.dialog.open(ReasonDialogComponent, {
      width: '700px',
      data: {
        exitcategorylist: this.exitcategorylist 
      }
    });
    dialogRef.afterClosed().subscribe((dialogResult) => {
      if (dialogResult) {
        this.reasons(this.offboarding.ExitID);
      }
    }, (error) => {
      this.error = error;
    });
  }


  Cancel() {
    this.router.navigateByUrl(
      `/Offboardinglist/tabIndex/${
        Number(sessionStorage.getItem("tabIndex")) || 0
      }`
    );
  }

  Reset() {
    this.offboardingForm.reset();
  }

  getEmployeeListforCC() {
    this.empsvc.getAllActiveEmployees().subscribe(
      (data: any[]) => {
        const tempList = [];
        this.empList = data;
        const pmCode = this.selectedPM && this.selectedPM.length > 0 ? this.selectedPM.split(' - ')[1] : null;
        const poCodes = this.selectedPO && this.selectedPO.length > 0 ? this.selectedPO.split(',').map(code => code.split(' - ')[1]).filter(Boolean) : [];
        const excludedCodes = [pmCode, ...poCodes, String(this.empCode)].filter(code => code);
        if (!pmCode && poCodes.length === 0) {
          this.empList.forEach((el) => {
            let item = el;
            item.recDisplayName = el.NamePerRecords + " - " + el.EmpCode;
            item.recEmpCode = el.EmpCode;
            tempList.push(item);
          });
        } else {
          this.empList.forEach((el) => {
            if (!excludedCodes.includes(String(el.EmpCode))) {
              let item = el;
              item.recDisplayName = el.NamePerRecords + " - " + el.EmpCode;
              item.recEmpCode = el.EmpCode;
              tempList.push(item);
            }
          });
        }
        this.empList = tempList;
        this.filteredEmpList = this.empList;
      },
      (error) => (this.error = error)
    );
  }

  getEmployeeList() {
    this.loader = true;
    this.empsvc.getAllActiveEmployees().subscribe(
      (data: any[]) => {
        if (!isNullOrUndefined(this.empCode)) {
          const employee = data.find((x) => x.EmpCode == this.empCode);
          if (employee) {
            this.empName = employee.NamePerRecords;
            this.employeeList = [employee];
            this.filteredList = this.employeeList;
          } else {
            this.employeeList = [];
            this.filteredList = [];
          }
        } else {
          this.employeeList = data;
          this.filteredList = data;
        }
      },
      (error) => (this.error = error)
    );
  }

  doFilter() {
    if (this.EmployeeCode) {
      this.filteredList = this.filter(this.employeeList);
    } else {
      this.filteredList = this.employeeList;
    }
  }

  removeExtraSpaces(str) {
    return str.replace(/\s+/g, "").trim();
  }

  filter(values) {
    const searchTerm = this.removeExtraSpaces(this.EmployeeCode.toLowerCase());

    return values.filter((res) => {
      if (searchTerm) {
        const nameMatches =
          res.NamePerRecords &&
          this.removeExtraSpaces(res.NamePerRecords.toLowerCase()).includes(
            searchTerm
          );
        const codeMatches =
          res.EmpCode && res.EmpCode.toString().includes(searchTerm);
        return nameMatches || codeMatches;
      }
      return true;
    });
  }

  detectChanges() {
    this.cdr.detectChanges();
  }

  SaveOffboardingDetails() {
    window.scrollTo(0, 0);
    this.loader = true;
    this.offboardingForm.markAllAsTouched();
    this.detectChanges();
    if (
      (isNullOrUndefined(this.empCode) &&
        this.offboardingForm.controls.employeeId.invalid) ||
      isNullOrUndefined(this.offboarding.ResignationDate) ||
      isNullOrUndefined(this.offboarding.LastWorkingDay) ||
      isNullOrUndefined(this.offboarding.ExitID) ||
      isNullOrUndefined(this.offboarding.ReasonID)
    ) {
      this.loader = false;
      this.toastr.warning("Please fill in the required fields");
      return;
    }

    if (this.offboarding.ExitID == 3) {
      this.offboarding.ReasonID = 9;
    }
    this.datePipe = new DatePipe("en-US");
    if (!isNullOrUndefined(this.offboarding.ResignationDate)) {
      this.offboarding.ResignationDate = new Date(
        this.datePipe.transform(
          this.offboarding.ResignationDate,
          this.config.dateFormat()
        )
      );
    }
    if (!isNullOrUndefined(this.offboarding.LastWorkingDay)) {
      this.offboarding.LastWorkingDay = new Date(
        this.datePipe.transform(
          this.offboarding.LastWorkingDay,
          this.config.dateFormat()
        )
      );
    }

    if (this.offboarding.ResignationDate > this.offboarding.LastWorkingDay) {
      this.loader = false;
      this.toastr.warning(
        "LWD should  be greater than or equal to Resignation Date."
      );
      return;
    }
    this.offboarding.CreatedBy = this.LoginEmpCode;
    this.offboarding.ModifiedBy = this.LoginEmpCode;
    this.offboarding.Status = "Saved";
    this.offboarding.InitiateLWDMail = true;
    if (
      this.offboarding.finalStatus === "Approved" ||
      this.offboarding.finalStatus === "Confirmed"
    ) {
      this.offboarding.FromEmp = true;
    } else {
      this.offboarding.FromEmp = false;
    }

    if (isNullOrUndefined(this.empCode)) {
      var id = this.EmployeeCode.split("-");
      this.offboarding.EmpCode = id[0];
    }
    if (isNullOrUndefined(this.empCode)) {
      var check = this.EmployeeCode.split("-");
      var mailCheckinList = this.employeeList.filter(
        (x) => x.EmpCode == check[0]
      );
      if (mailCheckinList.length == 0) {
        this.loader = false;
        this.toastr.warning("Please select an employee from dropdown.");
        this.EmployeeCode = "";
        return;
      }
    }
    var now = new Date();
    var mm = now.getMonth() + 1;
    var currentYear;
    var year;
    currentYear = now.getFullYear();
    year = now.getFullYear().toString().substr(2, 2);
    if (3 < mm) {
      currentYear = now.getFullYear();
      year = now.getFullYear().toString().substr(2, 2);
    } else {
      currentYear = now.getFullYear() - 1;
      year = (now.getFullYear() - 1).toString().substr(2, 2);
    }
    this.offboarding.FinancialYear = currentYear + "-" + (parseInt(year) + 1);
    this.offboarding.NewITData = true;
    this.offboarding.ProjectManagers = this.selected ? this.selected : null;

    if (this.selectedMasterIds) {
      const ccEntries = this.selectedMasterIds
        .map((empCode) => {
          const employee = this.empList.find((emp) => emp.EmpCode === empCode);
          return employee ? employee.recDisplayName : null;
        })
        .filter((entry) => entry !== null);

      this.offboarding.CC = ccEntries.join(",");
    } else {
      this.offboarding.CC = null;
    }

    this.empsvc.SaveOffboardingDetails(this.offboarding).subscribe(
      (data: Offboarding) => {
        if (data.ErrorMsg === "Already existed") {
          this.toastr.error(
            "Resignation has already been submitted for this employee"
          );
          this.loader = false;
          this.offboarding.Status = "";
          this.offboarding.finalStatus = "";
        } else {
          this.toastr.success("Form Saved Successfully.");
          this.loader = false;
          this.getEmployeeListforCC();
          // this.router.navigateByUrl("/Offboardinglist/tabIndex/0");
          this.router.navigateByUrl(
            `/Offboardinglist/tabIndex/${
              Number(sessionStorage.getItem("tabIndex")) || 0
            }`
          );
        }
      },
      (error) => (this.error = error)
    );
  }
  setLastWorkingDate(resignationDate: Date) {
    const resignDate = new Date(resignationDate);
    const fromYear = resignDate.getFullYear();
    const fromMonth = resignDate.getMonth();
    const fromDate = resignDate.getDate();
    this.minDate = new Date(fromYear, fromMonth, fromDate);
  }
  handleFile(event) {
    if (event.target.files == undefined) {
      this.offboarding.ExitEmailFile = null;
    }
    const files: FileList = event.target.files;
    if (files && files.length > 0) {
      if (!this.validFileType(files[0])) {
        this.toastr.warning(
          "File name " + files[0].name + ": Not a valid file type."
        );
        // Clear the input
        event.srcElement.value = null;
        event.currentTarget.value = null;
      }
      //  Don't allow file sizes over 1MB
      if (files[0].size < this.MAX_SIZE) {
        this.offboarding.ExitEmailFile = this.file_Svc.readAndUploadFile(files);
        this.offboarding.ExitEmailFilePath = null;
      } else {
        this.toastr.warning(
          " File: " +
            files[0].name +
            " exceeds 1MB hence it cannot be uploaded."
        );
        //  Clear the input
        event.srcElement.value = null;
        event.currentTarget.value = null;
        //this.FinanceForm.controls.CancelledChequeFile.reset();
      }
    }
  }
  validFileType(file) {
    let types = File_Types;
    return types.includes(file.type);
  }
  getPeopleManagerCodeandMail(empCode) {
    this.empsvc
      .getPeopleManagerCodeandMail(empCode || this.empCode)
      .subscribe((data: any) => {
        this.peopleManagerEmail = data && data.ManagerEmail;
        this.peopleManagerName = data && data.ManagerName;
      });
  }
  InitiateExit() {
    window.scrollTo(0, 0);
    this.loader = true;
    this.offboardingForm.markAllAsTouched();
    this.cdr.detectChanges();
    if (
      isNullOrUndefined(this.empCode) &&
      this.offboardingForm.controls.employeeId.invalid
    ) {
      this.loader = false;

      this.toastr.warning("Employee Code is required.");
      return;
    }
    this.datePipe = new DatePipe("en-US");
    if (!isNullOrUndefined(this.offboarding.ResignationDate)) {
      this.offboarding.ResignationDate = new Date(
        this.datePipe.transform(
          this.offboarding.ResignationDate,
          this.config.dateFormat()
        )
      );
    }
    if (!isNullOrUndefined(this.offboarding.LastWorkingDay)) {
      this.offboarding.LastWorkingDay = new Date(
        this.datePipe.transform(
          this.offboarding.LastWorkingDay,
          this.config.dateFormat()
        )
      );
    }

    if (this.offboarding.ResignationDate > this.offboarding.LastWorkingDay) {
      this.loader = false;
      this.toastr.warning(
        "LWD should  be greater than or equal to Resignation Date."
      );
      return;
    }
    if (this.offboarding.ResignationDate == null) {
      this.loader = false;
      this.toastr.warning("Resignation Date required.");
      return;
    }
    if (this.offboarding.ExitID == null) {
      this.loader = false;
      this.toastr.warning("Exit type required.");
      return;
    }
    if (this.offboarding.ReasonID == null) {
      this.loader = false;
      this.toastr.warning("Reason required.");
      return;
    }
    this.datePipe = new DatePipe("en-US");
    this.offboarding.ResignationDate = new Date(
      this.datePipe.transform(
        this.offboarding.ResignationDate,
        this.config.dateFormat()
      )
    );
    this.offboarding.LastWorkingDay = new Date(
      this.datePipe.transform(
        this.offboarding.LastWorkingDay,
        this.config.dateFormat()
      )
    );
    //  this.offboarding.CreatedBy = this.LoginEmpCode;
    this.offboarding.ModifiedBy = this.LoginEmpCode;

    this.offboarding.PeopleManagerEmail = this.peopleManagerEmail;
    this.offboarding.PeopleManagerName = this.peopleManagerName;
    this.offboarding.Status = "Initiated";

    //this.offboarding.EmpCode = this.EmployeeCode;
    if (isNullOrUndefined(this.empCode)) {
      var id = this.EmployeeCode.split("-");
      this.offboarding.EmpCode = id[0];
    }
    var now = new Date();
    var mm = now.getMonth() + 1;
    var currentYear;
    var year;
    currentYear = now.getFullYear();
    year = now.getFullYear().toString().substr(2, 2);
    if (3 < mm) {
      currentYear = now.getFullYear();
      year = now.getFullYear().toString().substr(2, 2);
    } else {
      currentYear = now.getFullYear() - 1;
      year = (now.getFullYear() - 1).toString().substr(2, 2);
    }
    this.offboarding.FinancialYear = currentYear + "-" + (parseInt(year) + 1);
    this.offboarding.NewITData = true;
    this.offboarding.clickingInitaiteExit = true;

    if (this.selectedMasterIds) {
      const ccEntries = this.selectedMasterIds
        .map((empCode) => {
          const employee = this.empList.find((emp) => emp.EmpCode === empCode);
          return employee ? employee.recDisplayName : null;
        })
        .filter((entry) => entry !== null);

      this.offboarding.CC = ccEntries.join(",");
    } else {
      this.offboarding.CC = null;
    }

    this.empsvc.InitiateOffboardingDetails(this.offboarding).subscribe(
      (data: Offboarding) => {
        if (data.ErrorMsg === "Already existed") {
          this.toastr.error("User already submitted resignation");
          this.loader = false;
        } else {
          this.toastr.success("Exit Initiated Successfully.");
          this.loader = false;
          // this.router.navigateByUrl("/Offboardinglist/tabIndex/0");
          this.router.navigateByUrl(
            `/Offboardinglist/tabIndex/${
              Number(sessionStorage.getItem("tabIndex")) || 0
            }`
          );
        }
      },
      (error) => (this.error = error)
    );
  }

  Rejected() {
    this.commentsReq = true;
    this.offboardingForm.markAllAsTouched();

    if (
      this.offboarding.HRResignationComments != null &&
      this.offboarding.HRResignationComments.trim() != ""
    ) {
      const message = "Are you sure you want to reject?";
      const dialogData = new ConfirmDialogModel(" ", message, "Submit", "OK", "Cancel");

      const dialogRef = this.dialog.open(ConfirmDialogComponent, {
        maxWidth: "500px",
        data: dialogData,
      });

      dialogRef.afterClosed().subscribe((dialogResult) => {
        if (dialogResult) {      
          this.updateOffboardingResgnStatus.HRResignationComments =
            this.offboarding.HRResignationComments;
          this.updateOffboardingResgnStatus.ManagerResignationComments =
            this.offboarding.ManagerResignationComments;
          this.updateOffboardingResgnStatus.status = "Rejected";
          this.updateOffboardingResgnStatus.OffboardingID = this.offboarding.ID;
          this.updateOffboardingResgnStatus.EmpCode = this.empCode;
          this.updateOffboardingResgnStatus.ExitID = this.offboarding.ExitID;
          this.updateOffboardingResgnStatus.Designation = "HR";
          this.updateOffboardingResgnStatus.IndicativeLWD =
            this.offboarding.IndicativeLWD;
          this.updateOffboardingResgnStatus.LastWorkingDay =
            this.offboarding.LastWorkingDay;
          this.updateOffboardingResgnStatus.ModifiedBy = this.LoginEmpCode;
          this.updateOffboardingResgnStatus.ResignationDate =
            this.offboarding.ResignationDate;
          this.updateOffboardingResgnStatus.ReasonID = this.offboarding.ReasonID;
          this.updateOffboardingResgnStatus.ProjectManagers =
            this.offboarding.ProjectManagers;
          this.updateOffboardingResgnStatus.CC = this.offboarding.CC;

          if (this.selectedMasterIds) {
            const ccEntries = this.selectedMasterIds
              .map((empCode) => {
                const employee = this.empList.find(
                  (emp) => emp.EmpCode === empCode
                );
                return employee ? employee.recDisplayName : null;
              })
              .filter((entry) => entry !== null);

            this.updateOffboardingResgnStatus.CC = ccEntries.join(",");
          } else {
            this.updateOffboardingResgnStatus.CC = null;
          }

          this.empsvc
            .UpdateResignationStatus(this.updateOffboardingResgnStatus)
            .subscribe(
              (data: any) => {
                this.toastr.success("Resignation Rejected Successfully.");
                this.router.navigateByUrl("/Offboardinglist/tabIndex/1");
                window.scrollTo(0, 0);

                setTimeout(() => {
                  this.loader = false;
                }, 1000);
              },
              (error) => {
                this.error = error;
                this.loader = false;
              }
            );
        } 
      }, (error) => {
        this.loader = false;
        this.toastr.error("Error during the confirmation process.");
      });
    } else {
      this.offboardingForm.markAllAsTouched();
    }
  }

}
